import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './accommodation-type.reducer';

export const AccommodationTypeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const accommodationTypeEntity = useAppSelector(state => state.accommodationType.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="accommodationTypeDetailsHeading">
          <Translate contentKey="apiLocationApp.accommodationType.detail.title">AccommodationType</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{accommodationTypeEntity.id}</dd>
          <dt>
            <span id="geographicLevel">
              <Translate contentKey="apiLocationApp.accommodationType.geographicLevel">Geographic Level</Translate>
            </span>
          </dt>
          <dd>{accommodationTypeEntity.geographicLevel}</dd>
          <dt>
            <span id="date">
              <Translate contentKey="apiLocationApp.accommodationType.date">Date</Translate>
            </span>
          </dt>
          <dd>{accommodationTypeEntity.date}</dd>
          <dt>
            <span id="geography">
              <Translate contentKey="apiLocationApp.accommodationType.geography">Geography</Translate>
            </span>
          </dt>
          <dd>{accommodationTypeEntity.geography}</dd>
          <dt>
            <span id="geographyCode">
              <Translate contentKey="apiLocationApp.accommodationType.geographyCode">Geography Code</Translate>
            </span>
          </dt>
          <dd>{accommodationTypeEntity.geographyCode}</dd>
          <dt>
            <span id="totalAllHouseholds">
              <Translate contentKey="apiLocationApp.accommodationType.totalAllHouseholds">Total All Households</Translate>
            </span>
          </dt>
          <dd>{accommodationTypeEntity.totalAllHouseholds}</dd>
          <dt>
            <span id="detached">
              <Translate contentKey="apiLocationApp.accommodationType.detached">Detached</Translate>
            </span>
          </dt>
          <dd>{accommodationTypeEntity.detached}</dd>
          <dt>
            <span id="semiDetached">
              <Translate contentKey="apiLocationApp.accommodationType.semiDetached">Semi Detached</Translate>
            </span>
          </dt>
          <dd>{accommodationTypeEntity.semiDetached}</dd>
          <dt>
            <span id="terraced">
              <Translate contentKey="apiLocationApp.accommodationType.terraced">Terraced</Translate>
            </span>
          </dt>
          <dd>{accommodationTypeEntity.terraced}</dd>
          <dt>
            <span id="purposeBuiltBlockFlats">
              <Translate contentKey="apiLocationApp.accommodationType.purposeBuiltBlockFlats">Purpose Built Block Flats</Translate>
            </span>
          </dt>
          <dd>{accommodationTypeEntity.purposeBuiltBlockFlats}</dd>
          <dt>
            <span id="convertedSharedHouse">
              <Translate contentKey="apiLocationApp.accommodationType.convertedSharedHouse">Converted Shared House</Translate>
            </span>
          </dt>
          <dd>{accommodationTypeEntity.convertedSharedHouse}</dd>
          <dt>
            <span id="convertedBuilding">
              <Translate contentKey="apiLocationApp.accommodationType.convertedBuilding">Converted Building</Translate>
            </span>
          </dt>
          <dd>{accommodationTypeEntity.convertedBuilding}</dd>
          <dt>
            <span id="commercialBuilding">
              <Translate contentKey="apiLocationApp.accommodationType.commercialBuilding">Commercial Building</Translate>
            </span>
          </dt>
          <dd>{accommodationTypeEntity.commercialBuilding}</dd>
          <dt>
            <span id="caravanMobile">
              <Translate contentKey="apiLocationApp.accommodationType.caravanMobile">Caravan Mobile</Translate>
            </span>
          </dt>
          <dd>{accommodationTypeEntity.caravanMobile}</dd>
        </dl>
        <Button tag={Link} to="/accommodation-type" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/accommodation-type/${accommodationTypeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AccommodationTypeDetail;
